
export class CopyFromProposalDTO{
    SourcePartInfoId: number;
    SourceProposalId: number;
    EffectiveFrom: Date;
}
